function splitParts(ogContent: string): (string | undefined)[] {
  let partsList: (string | undefined)[] = []
  // eslint-disable-next-line regexp/no-misleading-capturing-group,regexp/no-super-linear-backtracking -- Reason: needed for matching
  const regex = /afstand tot (?:dichtstbijzijnde )?([a-z() ]+):?\s?(?:naar\s)?([a-z ]+)?(?:circa|maximaal)\s(\d+\s[a-z]+)(?:,?\s(?:en\s)?(?:naar\s)?([a-z ]+)?(?:circa|maximaal)\s(\d+\s[a-z]+))?(?:,?\s(?:en\s)?(?:naar\s)?([a-z ]+)?(?:circa|maximaal)\s(\d+\s[a-z]+))?(?:,?\s(?:en\s)?(?:naar\s)?([a-z ]+)?(?:circa|maximaal)\s(\d+\s[a-z]+))?/i
  const match = ogContent.match(regex)
  if (match) {
    partsList = match.slice(1)
  }
  return partsList
}

function capital(val: string): string {
  if (val[0] !== '(') {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1)
  }
  else {
    return val[0] + String(val).charAt(1).toUpperCase() + String(val).slice(2)
  }
}

function normalizeUnits(val: string): string {
  return String(val).replace(/kilometer/i, 'km').replace(/meter/i, 'm')
}

export function sanitizeContentNl(ogContentList: string[]): string[] {
  const resultList: string[] = []
  ogContentList.forEach((element) => {
    const parts = splitParts(element)
    if (parts.length === 0) {
      resultList.push(capital(element.trim()))
    }
    else {
      if (parts[0] && parts[2] && parts[1] === undefined) {
        resultList.push(`${capital(parts[0].trim())}: ${normalizeUnits(parts[2].trim())}`)
      }
      else if (parts[0] && parts[1] && parts[2]) {
        resultList.push(`${capital(parts[0].trim())} ${capital(parts[1].trim())}: ${normalizeUnits(parts[2].trim())}`)
        if (parts[3] && parts[4]) {
          resultList.push(`${capital(parts[0].trim())} ${capital(parts[3].trim())}: ${normalizeUnits(parts[4].trim())}`)
        }
        if (parts[5] && parts[6]) {
          resultList.push(`${capital(parts[0].trim())} ${capital(parts[5].trim())}: ${normalizeUnits(parts[6].trim())}`)
        }
        if (parts[7] && parts[8]) {
          resultList.push(`${capital(parts[0].trim())} ${capital(parts[7].trim())}: ${normalizeUnits(parts[8].trim())}`)
        }
      }
    }
  })

  return resultList
}
